import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICONS_FOLDER_PATH } from '../../shared/component/all-icons/all-icons.component';

@Component({
  selector: 'app-empty-state-standard',
  templateUrl: './empty-state-standard.component.html',
  styleUrls: ['./empty-state-standard.component.scss'],
})
export class EmptyStateStandardComponent {
  @Input() isAdmin = false;
  @Input() heading: string;
  @Input() description: string;
  @Input() buttonText: string;
  /**
   * Main icon displayed above the text, not the button icon.
   * The expected value is the name of the icon file located in the '/assets/svg/optimized/' folder.
   */
  @Input() icon = 'empty-tray.svg';
  @Input() secondButtonText: string;
  @Input() buttonIconName: string;
  @Input() secondButtonIconName: string;
  // if modal inside white-card use default class = 'font-2'
  // else outside white-card use 'title-3'
  @Input() titleClass = 'font-2';
  // use this trigger for true if needs to use 2 buttons in the component instead of one
  @Input() useTwoButtons = false;
  @Output() buttonClick = new EventEmitter<void>();
  @Output() secondButtonClick = new EventEmitter<void>();

  get iconName(): string {
    return ICONS_FOLDER_PATH + this.icon;
  }
}
